import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";

/**
 * Tells the click that ends a text drag inside an element (mouseup after
 * selecting still fires `click`) from a plain click, so a toggle on a
 * selectable surface skips only the former. Spread `onPointerDown` onto the
 * element and check `endsDrag` in its click handler; a selection left over
 * from earlier does not block the click.
 */
export function useTextDragGuard() {
  const $ = _c(1);
  const before = useRef("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      onPointerDown: () => {
        before.current = document.getSelection()?.toString() ?? "";
      },
      endsDrag: t1 => {
        const {
          currentTarget,
          detail
        } = t1;
        const selection = currentTarget.ownerDocument.getSelection();
        if (detail === 0 || !selection || selection.isCollapsed) {
          return false;
        }
        const inside = [selection.anchorNode, selection.focusNode].some(node => node !== null && currentTarget.contains(node));
        return inside && selection.toString() !== before.current;
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}